import loadable from '@loadable/component';

export const ReportsDetailGraphicConfigurationFilterDepartments = loadable(
  () => import('./ReportsDetailGraphicConfigurationFilterDepartments'),
);
